import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M12 13.4c-1.5-2.5-2-5-1.5-7s2.5-2.5 3.5-1 0 4.5-2 8m0 0c2.915-.049 5.33.768 6.812 2.201s.915 3.415-.884 3.531S14.031 16.882 12 13.4m0 0c-1.415 2.549-3.33 4.232-5.312 4.799s-3.415-.915-2.616-2.531S7.969 13.418 12 13.4"
    }, null, -1)
  ])))
}
export default { render: render }